// Generated from build58 src/features/archive/archiveGoals.ts. Run scripts/generate-archive-reference.cjs.
export const archiveGoalDefinitions = [
  {
    type: 'WRITTEN_REVIEWS',
    label: '작성할 리뷰',
    suffix: '개',
    weekPresets: [3, 5, 10],
    monthPresets: [5, 10, 20],
  },
  {
    type: 'NEW_ARTISTS',
    label: '새 아티스트 발견',
    suffix: '명',
    weekPresets: [1, 3, 5],
    monthPresets: [3, 5, 10],
  },
  {
    type: 'ACTIVE_DAYS',
    label: '음악 기록한 날',
    suffix: '일',
    weekPresets: [1, 3, 5],
    monthPresets: [7, 10, 20],
  },
];
// API enum remains compatible, but retired album goals are no longer offered
// or included in the personal goal progress UI.
export const editableArchiveGoalDefinitions = archiveGoalDefinitions.filter(
  (goal) => goal.type !== 'LISTENED_ALBUMS',
);
export const defaultArchiveGoalDrafts = (periodType) => ({
  LISTENED_ALBUMS: '0',
  WRITTEN_REVIEWS: periodType === 'WEEK' ? '3' : '10',
  NEW_ARTISTS: periodType === 'WEEK' ? '1' : '3',
  ACTIVE_DAYS: periodType === 'WEEK' ? '3' : '10',
});
export const archiveGoalTargets = (archive) => {
  const items = archive?.goal.items;
  return {
    LISTENED_ALBUMS: 0,
    WRITTEN_REVIEWS:
      items?.find((item) => item.type === 'WRITTEN_REVIEWS')?.target ??
      archive?.goal.reviewTarget ??
      0,
    NEW_ARTISTS: items?.find((item) => item.type === 'NEW_ARTISTS')?.target ?? 0,
    ACTIVE_DAYS: items?.find((item) => item.type === 'ACTIVE_DAYS')?.target ?? 0,
  };
};
export const archiveProgressValue = (archive, type) =>
  ({
    LISTENED_ALBUMS: archive.progress.listenedAlbums,
    WRITTEN_REVIEWS: archive.progress.writtenReviews,
    NEW_ARTISTS: archive.progress.newArtists ?? 0,
    ACTIVE_DAYS: archive.progress.activeDays ?? 0,
  })[type];
